import * as types from "./actionTypes";

export function resetState() {
	return { type: types.RESET_STATE };
}
